import { View } from "react-native";
import { Modal } from "../../components";
import { CheckboxItem } from "../../components";
import { Control, Controller } from "react-hook-form";
import { JobPreferenceField, JobPreferencesFormData } from "./types";

interface LocationsModalProps {
  control: Control<JobPreferencesFormData>;
  locations: JobPreferenceField[];
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

const otherLocations: JobPreferenceField[] = [
  { label: "International Positions", value: "International Positions", name: "openToInternational" },
];

const LocationsModal = ({ control, locations, visible, setVisible }: LocationsModalProps) => (
  <Modal
    {...{
      title: "Select Preferred Job Locations",
      fullScreen: true,
      visible: visible,
      onDismiss: () => setVisible(false),
      hasBorder: true,
    }}
  >
    <View className="mb-10 bg-white">
      {[...otherLocations, ...locations].map((location, i) => (
        <Controller
          key={location.value}
          name={location.name ? location.name : `jobLocations.${location.value}`}
          control={control}
          defaultValue={false}
          render={({ field: { onChange, value } }) => (
            <CheckboxItem
              {...{
                className: `${i === 0 && "border-b-4 border-sky-lighter"} `,
                labelStyle: `text-regular-tight text-ink-darkest p-2`,
                position: "trailing",
                label: location.label,
                value,
                onChange,
              }}
            />
          )}
        />
      ))}
    </View>
  </Modal>
);

export default LocationsModal;
